import { Box, Paper } from '@material-ui/core';
import React from 'react';
import { getPrimaryColorGradient } from '../utils/colors';

const getGradient = (palette: string) => {
  const gradients = [1, 2, 3, 4, 5, 6].map((num, index) => {
    const colors = getPrimaryColorGradient(num, palette);
    const isLastElement = index === [1, 2, 3, 4, 5, 6].length - 1;
    return (
      <Box
        display="flex"
        flexDirection="column"
        textAlign="center"
        key={num}
        style={{ marginRight: isLastElement ? '20px' : '0' }}
      >
        <b>{num}</b>
        {colors.map((c) => (
          <Box
            width="40px"
            height="30px"
            margin="4px"
            key={c}
            style={{ backgroundColor: c }}
          />
        ))}
      </Box>
    );
  });
  return gradients;
};

const TestGetGradientFn = () => (
  <Paper>
    <Box
      className="get-gradient-box"
    >
      {getGradient('green')}
      {getGradient('purple')}
      {getGradient('blue-purple')}
    </Box>
  </Paper>
);

export default TestGetGradientFn;
